import { api } from "@/utils/api";

export default class MetereologicalRepository {
  async getMeteorologicalInfo(): Promise<any> {
    const response = await api.get(`meteorological/`);
    return response.data;
  }
}
